module.exports = __webpack_public_path__ + "img/banner-shape-1.f3fed17a.png";